import React, {memo} from "react";
import {Link} from "react-router-dom";
import {FrontendRoutes} from "../../constants";

const styles = {
    root: {
        margin: '0 auto',
        width: '35%'
    },
    titleDiv: {
        fontSize: '1.2vw',
        fontFamily: 'DINPro-Bold',
        height: 'auto'
    },
    title: {
        padding: '10px 20px',
        lineHeight: '3vw'
    },
    closeIcon: {
        padding: '0.2vw 0.5vw',
        cursor: "pointer",
        lineHeight: '3vw'
    },
    customScrollbar: {
        margin: '3.5vw 3vw',
        height: '14vh',
        overflowY: 'auto',
        display: 'flex',
        alignItems: 'center'
    },
    submittedText: {
        fontSize: '1.1vw',
        textAlign: 'justify'
    },
    downloadCanvas: {
        position: 'absolute',
        zIndex: 4,
        top: 8,
        left: 5,
        margin: 'auto',
        display: 'none'
    },
    buttons: {
        margin: '3.5vw 3vw',
        display: 'flex',
        justifyContent: 'space-between'
    }
}

const SUBMITTED_TEXT = "Your photo has been submitted to be published to the Social Wall soon. You may also download or share your photo on your social media or visit the Social Wall to view other photos and messages.";

const SubmittedDialog = ({onClose, onDownload, onNext}) => {

    return (<div className="coverup photobooth-cover termbox" style={styles.root}>
        <div style={styles.titleDiv}>
            <span style={styles.title}>Photo Submitted!</span>
            <span className="pull-right"
                  style={styles.closeIcon}
                  onClick={onClose}>X</span>
        </div>
        <div style={styles.customScrollbar}
             className={'custom-scrollbar'}>
            <div style={styles.submittedText}>
                {SUBMITTED_TEXT}
            </div>
        </div>
        <canvas id="download_canvas"
                width="1620"
                height="1620"
                style={styles.downloadCanvas}/>
        <div style={styles.buttons}>
            <Link to='#'><span className="submitted-btn" onClick={onDownload}>Download</span></Link>
            <Link to='#'><span className="submitted-btn" onClick={onNext}>Share</span></Link>
            <Link to={FrontendRoutes.SOCIAL_WALL}><span className="submitted-btn">Social Wall</span></Link>
        </div>
    </div>);
}

export default memo(SubmittedDialog)